/**
 * The roadmap page's chrome (`KLQ-20260904-003`).
 *
 * **Four keys, and none of them is roadmap content.** The items, the stage names, the preamble
 * and the invitation are all translated in the backend's TOML files and arrive over the wire —
 * deliberately never part of this bundle (§A: data imported into the frontend is data published
 * to anybody with `curl`). What is left here is the loading state, the failure state, and the
 * two lines about the response itself. If a fifth key here would carry roadmap text, it belongs
 * in `backend/src/kalqa/domains/roadmap/content/` instead.
 */
export const roadmapEn = {
  loading: 'Loading…',
  failed: 'The roadmap could not be loaded. Try again.',
  updated: 'Updated {date}.',
  originalLanguage: 'Shown in the original language ({locale}).',
} as const;

export type RoadmapMessageKey = keyof typeof roadmapEn;
